// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1ex7X7s-snIclixekS1xWg {\r\n\r\n    background-color: var(--utility-silver);\r\n    color: var(--utility-black);\r\n\r\n    height: 18px;\r\n    border-radius: 9px;\r\n    line-height: 18px;\r\n    padding: 0 9px;\r\n    font-size: 8px;\r\n    text-transform: uppercase;\r\n    letter-spacing: 0.5px;\r\n    \r\n    display: inline-flex;\r\n    align-items: center;\r\n\r\n}\r\n\r\n\r\n._11soGkMiz3VT4VYdjzNcTm {\r\n    background-color: var(--action);\r\n    color: var(--on-action);\r\n}", ""]);
// Exports
exports.locals = {
	"pill": "_1ex7X7s-snIclixekS1xWg",
	"action": "_11soGkMiz3VT4VYdjzNcTm"
};
module.exports = exports;
